import { render, staticRenderFns } from "./SignatureMaker.vue?vue&type=template&id=bbacd558&scoped=true"
import script from "./SignatureMaker.vue?vue&type=script&lang=js"
export * from "./SignatureMaker.vue?vue&type=script&lang=js"
import style0 from "./SignatureMaker.vue?vue&type=style&index=0&id=bbacd558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbacd558",
  null
  
)

export default component.exports